import styled from '@emotion/styled';
import AccessibilityIcon from '../../../../assets/icons/accessibility.svg';
import { useReciteMe } from '../../../../features/shared/recite-me/useReciteMe';
import { Css, Flex, Responsive } from '../../../../ui';
import GlobalSearch from '../../global-search/GlobalSearch';
import SecondaryNavigationButton from './SecondaryNavigationButton';

export default function SecondaryNavigation() {
	const recite = useReciteMe();

	return (
		<StyledSecondaryNavContainer alignItems="center">
			<GlobalSearch />
			<SecondaryNavigationButton
				icon={AccessibilityIcon}
				onClick={recite.openToolbar}
			>
				Accessibility
			</SecondaryNavigationButton>
		</StyledSecondaryNavContainer>
	);
}

const StyledSecondaryNavContainer = styled(Flex)`
	justify-content: flex-end;
	gap: ${Css.pxToRem(16)};

	@media (${Responsive.getMediaQueryForBreakpoint('13inch-navigation')}) {
		gap: ${Css.pxToRem(8)};
	}
`;
